import React from 'react';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import type { SxProps, Theme } from '@mui/material/styles';

type GameViewedIconProps = {
  viewed: boolean;
  sx?: SxProps<Theme>;
};

const GameViewedIcon = ({ viewed, sx }: GameViewedIconProps) => {
  if (!viewed) {
    return null;
  }

  return (
    <VisibilityOutlinedIcon
      aria-label="Previously viewed"
      titleAccess="Previously viewed"
      sx={{
        fontSize: 14,
        color: 'text.secondary',
        flexShrink: 0,
        opacity: 0.75,
        ...sx,
      }}
    />
  );
};

export default GameViewedIcon;
